import React from 'react';
import PropTypes from 'prop-types';

import FilterNumberPair from "components/search_sidebar/filter_number_pair";
import FilterInput from "components/search_sidebar/filter_input";
import FilterSelect from 'components/search_sidebar/filter_select';
import FilterCheckboxGroup from "components/search_sidebar/filter_checkbox_group";
import FilterDatePickerPair from 'components/search_sidebar/filter_datepicker_pair';


export default class BuildingFilters extends React.Component {
  lotUnits = [{ id: 'acres', value: 'acres', label: 'Acres' }];

  static propTypes = {
    buildingClasses: PropTypes.array.isRequired,
    filterKeyMappings: PropTypes.object.isRequired,
    filterLabelMappings: PropTypes.object.isRequired,
    investmentTypes: PropTypes.array.isRequired,
    propertyFilter: PropTypes.shape({
      lotUnits: PropTypes.string,
      apnNumber: PropTypes.string,
      maxBuildingSize: PropTypes.string,
      maxAvailableSF: PropTypes.string,
      maxCeilingHeight: PropTypes.string,
      maxLotSize: PropTypes.string,
      maxMortgageAmount: PropTypes.string,
      maxMortgageRecordedDate: PropTypes.string,
      maxNumUnits: PropTypes.string,
      maxYearBuilt: PropTypes.string,
      minAvailableSF: PropTypes.string,
      minBuildingSize: PropTypes.string,
      minCeilingHeight: PropTypes.string,
      minLotSize: PropTypes.string,
      minMortgageAmount: PropTypes.string,
      minMortgageRecordedDate: PropTypes.string,
      minNumUnits: PropTypes.string,
      minYearBuilt: PropTypes.string
    }).isRequired,
    selectedBuildingClasses: PropTypes.array.isRequired,
    selectedInvestmentTypes: PropTypes.array.isRequired,
    onBuildingClassChange: PropTypes.func.isRequired,
    onInvestmentTypeChange: PropTypes.func.isRequired,
    onPropertyFilterChange: PropTypes.func.isRequired
  };

  handleChange = (e, name) => {
    const { onPropertyFilterChange } = this.props;

    onPropertyFilterChange(e, name);
  }

  render() {
    const {
      buildingClasses,
      filterKeyMappings,
      filterLabelMappings,
      investmentTypes,
      propertyFilter,
      selectedBuildingClasses,
      selectedInvestmentTypes,
      onBuildingClassChange,
      onInvestmentTypeChange
    } = this.props;

    return (
      <React.Fragment>
        <div className="building-information">
          <div className="row left-buffer-sm right-buffer-sm hidden-xs hidden-sm">
            <div className="col-md-12 pl-0">
              <FilterCheckboxGroup
                label="Investment Type"
                options={investmentTypes}
                selected={selectedInvestmentTypes}
                onChange={onInvestmentTypeChange}
              />
            </div>
          </div>
          <div className="row left-buffer-sm right-buffer-sm hidden-xs hidden-sm">
            <div className="col-md-12 pl-0">
              <FilterCheckboxGroup
                inline
                label="Class"
                options={buildingClasses}
                selected={selectedBuildingClasses}
                onChange={onBuildingClassChange}
              />
            </div>
          </div>
          <div className="row left-buffer-sm right-buffer-sm">
            <div className="pl-0 col-md-9">
              <FilterNumberPair
                filter={propertyFilter}
                label={filterLabelMappings['lotSize']}
                name="lotSize"
                valueKeys={filterKeyMappings['lotSize']}
                onChange={this.handleChange}
              />
            </div>
            <div className="top-buffer-xs pl-0 col-md-3 hidden-xs hidden-sm">
              <FilterSelect
                defaultValue="sf"
                options={this.lotUnits}
                placeholder="SF"
                value={propertyFilter.lotUnits}
                onChange={e => this.handleChange(e, 'lotUnits')}
              />
            </div>
          </div>
          <div className="row left-buffer-sm right-buffer-sm hidden-xs hidden-sm">
            <div className="pl-0 col-md-12">
              <FilterInput
                label={filterLabelMappings['apnNumber']}
                name="apnNumber"
                placeholder="Parcel Number"
                value={propertyFilter.apnNumber}
                onChange={e => this.handleChange(e, 'apnNumber')}
              />
            </div>
          </div>
          <div className="row left-buffer-sm right-buffer-sm">
            <div className="pl-0 col-md-9">
              <FilterNumberPair
                filter={propertyFilter}
                label={filterLabelMappings['buildingSize']}
                name="buildingSize"
                valueKeys={filterKeyMappings['buildingSize']}
                onChange={this.handleChange}
              />
            </div>
            <div className="top-buffer-xs pl-0 col-md-3 hidden-xs hidden-sm">
              <FilterSelect disabled placeholder="SF"/>
            </div>
          </div>
          <div className="row left-buffer-sm right-buffer-sm hidden-xs hidden-sm">
            <div className="pl-0 col-md-12">
              <FilterNumberPair
                filter={propertyFilter}
                label={filterLabelMappings['mortgageAmount']}
                name="mortgageAmount"
                valueKeys={filterKeyMappings['mortgageAmount']}
                onChange={this.handleChange}
              />
            </div>
          </div>
        </div>
        <div className="building-information">
          <div className="row left-buffer-sm right-buffer-sm">
            <div className="pl-0 col-md-9">
              <FilterNumberPair
                filter={propertyFilter}
                label={filterLabelMappings['numUnits']}
                name="numUnits"
                valueKeys={filterKeyMappings['numUnits']}
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div className="row left-buffer-sm right-buffer-sm">
            <div className="pl-0 col-md-9">
              <FilterNumberPair
                filter={propertyFilter}
                label={filterLabelMappings['ceilingHeight']}
                name="ceilingHeight"
                valueKeys={filterKeyMappings['ceilingHeight']}
                onChange={this.handleChange}
              />
            </div>
            <div className="top-buffer-xs pl-0 col-md-3 hidden-xs hidden-sm">
              <FilterSelect disabled placeholder="FT"/>
            </div>
          </div>
          <div className="row left-buffer-sm right-buffer-sm">
            <FilterNumberPair
              filter={propertyFilter}
              label={filterLabelMappings['yearBuilt']}
              name="yearBuilt"
              placeholder="Year"
              valueKeys={filterKeyMappings['yearBuilt']}
              onChange={this.handleChange}
            />
          </div>
          <div className="row left-buffer-sm right-buffer-sm">
            <div className="pl-0 col-md-9">
              <FilterNumberPair
                filter={propertyFilter}
                label={filterLabelMappings['availableSF']}
                name="availableSF"
                placeholder="Available SF"
                valueKeys={filterKeyMappings['availableSF']}
                onChange={this.handleChange}
              />
            </div>
            <div className="top-buffer-xs pl-0 col-md-3 hidden-xs hidden-sm">
              <FilterSelect disabled placeholder="SF"/>
            </div>
          </div>
          <div className="row left-buffer-sm right-buffer-sm visible-sm visible-xs">
            <div className="building-class">
              <FilterCheckboxGroup
                defaultKey="mobile"
                inline
                label="Class"
                options={buildingClasses}
                selected={selectedBuildingClasses}
                onChange={onBuildingClassChange}
              />
            </div>
          </div>
          <div className="row left-buffer-sm right-buffer-sm">
            <FilterDatePickerPair
              filter={propertyFilter}
              label={filterLabelMappings['mortgageRecordedDate']}
              name={filterLabelMappings['mortgageRecordedDate']}
              valueKeys={filterKeyMappings['mortgageRecordedDate']}
              onChange={this.handleChange}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
